import { useRef, useState } from 'react'
import AvatarEditor from 'react-avatar-editor'
import { useTranslation } from 'react-i18next'
import { EModalName } from '../../../types/enums'
import { Button, Input } from '../../atoms'
import {
  avatarEditorModal,
  buttonStyle,
  buttonsStyle,
  controls,
  inputContainer,
} from './index.css'

export const ModalAvatarEditor = (props: {
  image: File
  close: (base64?: string) => Promise<void>
}) => {
  const { t } = useTranslation()
  const editorRef = useRef<AvatarEditor>(null)
  const [scale, setScale] = useState<number>(1.2)

  const handleUpload = async () => {
    if (editorRef.current) {
      const canvas = editorRef.current.getImageScaledToCanvas()
      const dataURL = canvas.toDataURL()
      const base64 = dataURL.split(',')[1]
      await props.close(base64)
    } else {
      await props.close()
    }
  }

  const onChange = (value: number | undefined) => {
    if (value === undefined) {
      return
    }
    setScale(value)
  }

  return (
    <div className={avatarEditorModal}>
      {/* @ts-expect-error can't AvatarEditor as jsx  */}
      <AvatarEditor
        ref={editorRef}
        image={props.image}
        borderRadius={5000}
        color={[0, 0, 0, 0.9]}
        scale={scale}
        rotate={0}
      />
      <div className={controls}>
        <Input
          id='zoom'
          label='Zoom:'
          type='range'
          min='1'
          max='3'
          step='0.1'
          value={scale}
          className={inputContainer}
          onChange={onChange}
        />
      </div>
      <div className={buttonsStyle}>
        <Button
          className={buttonStyle}
          analytic={{
            name: 'cancel',
            params: {
              modal: EModalName.AVATAR_UPLOAD,
            },
          }}
          onClick={() => void props.close(undefined)}
        >
          {t('modal.confirmation.avatarUpload.cancel')}
        </Button>
        <Button
          type='submit'
          variant='primary'
          className={buttonStyle}
          analytic={{
            name: 'upload',
            params: {
              modal: EModalName.AVATAR_UPLOAD,
            },
          }}
          onClick={() => void handleUpload()}
        >
          {t('modal.confirmation.avatarUpload.confirm')}
        </Button>
      </div>
    </div>
  )
}
